<form class="example-form col-lg-12 col-md-12 col-sm-12 pr-0" [ngClass]="{'inputdisabled' :autodisabled }">
  <mat-form-field class="example-full-width custominputview width-100">
    <mat-label>UserName</mat-label>
    <input matInput  type="text" #name aria-label="Number" matInput [formControl]="myControl" autofocus="autofocus"
      [matAutocomplete]="auto" (keydown)="onKey($event)">
     <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="displayForm($event)"
      [displayWith]="displayFn" panelWidth="400px">
      <mat-option class="autocompleteid" *ngFor="let option of filteredOptions" (onSelectionChange)="fetchSelected(option)"
        [value]="option.LoginId" title="{{option.LoginId}}">
        {{option.LoginId}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
 
  <div class="errlblnrf errormsgposition no-report-found" *ngIf="lblNoRecord != undefined && lblNoRecord != ''">
    {{lblNoRecord}}
  </div>
</form>